import authLocalFe from '@blaze-cms/plugin-auth-local-fe';
import ecommerceComponents from '@blaze-cms/plugin-ecommerce-components';
import ipAuth from '@blaze-cms/plugin-auth-ip-fe';
import examplePlugin from './blaze-plugins/example';
import listQueryVariablesPlugin from './blaze-plugins/list-query-variables-plugin';
import nmComponents from './blaze-plugins/nm-components';

export default function buildConfig(config) {
  // To set custom plugins into the project.
  config.plugins.set(examplePlugin, {});
  config.plugins.set(listQueryVariablesPlugin, {});
  config.plugins.set(nmComponents, {});
  config.plugins.set(authLocalFe, {});
  config.plugins.set(ecommerceComponents, {});
  config.plugins.set(ipAuth, {
    providers: [{ providerKey: 'blaze_auth_subscription', providerName: 'Subscription auth' }]
  });

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
